import {TYPE_CLEAR_UNREAD} from "app/redux/chats&notifications/chatsTypes";

export const actionClearUnread = (chatId) => ({
  type: TYPE_CLEAR_UNREAD,
  payload: { chatId },
});
